module.exports = "img/social/linkedin.ab157f6.png";